import * as TYPES from './actions/types';


export const LOCAL_STORAGE_KEY = 'facility:contactUs';

export const initialState = {
  instructions: null,
  contacts: [],
};

const contactUsReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.CONTACTUS_INSTRUCTIONS_LOADED:
    case TYPES.CONTACTUS_INSTRUCTIONS_LOAD_FAILED:
    case TYPES.CONTACTUS_CONTACTS_LOADED:
    case TYPES.CONTACTUS_CONTACTS_LOAD_FAILED:
      newState = { ...state, ...action.state };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default contactUsReducer;
